export default __webpack_public_path__ + "static/media/mon_24.edc5f662.png";